export default "__VITE_ASSET__cc49374f__"